export const searchConstants = {
  SEARCH_HAS_ERRORED: 'SEARCH_HAS_ERRORED',
  SEARCH_IS_LOADING: 'SEARCH_IS_LOADING',
  SEARCH_FETCH_DATA_SUCCESS: 'SEARCH_FETCH_DATA_SUCCESS',
  SEARCH_SET_SEARCHSTRING: 'SEARCH_SET_SEARCHSTRING',
  SEARCH_SET_FILTER: 'SEARCH_SET_FILTER',
};

